import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { downloadWorkbook } from '@/lib/document-export';
import { goodsPrintHtml } from '@/lib/goods-print.mjs';
import { getActiveStore } from '@/lib/scope';

// Explicit rows/notes reflect the current filter, not a hidden unfiltered export.
export default function ReportActions({ title, headers, rows, notes = [], disabled = false, worksheet = false }) {
  const [paper, setPaper] = useState('A5'), [busy, setBusy] = useState(false);
  const report = () => ({ title, template: worksheet, headers: ['No.', ...headers], rows: rows.map((row, i) => [i+1, ...row.map(v => v ?? null)]),
    meta: [['Cabang (ID)', getActiveStore()], ['Waktu ekspor', new Date().toLocaleString('id-ID')]],
    notes: [...notes, `Cakupan: ${rows.length} baris sesuai data/filter yang ditampilkan. Bukan file impor otomatis.`] });
  const excel = async () => {
    setBusy(true);
    try { const data = report(); await downloadWorkbook({ ...data, notes: [...data.meta.map(([k,v]) => `${k}: ${v}`), ...data.notes], paper, template: worksheet }); }
    catch { toast.error('Ekspor Excel gagal. Periksa koneksi atau perkecil cakupan data.'); }
    finally { setBusy(false); }
  };
  const print = () => {
    const popup = window.open('', '_blank', 'width=1100,height=800');
    if (!popup) return toast.error('Izinkan popup untuk mencetak laporan.');
    popup.opener = null; popup.document.open(); popup.document.write(goodsPrintHtml('report', report(), { paper })); popup.document.close(); popup.focus(); popup.setTimeout(() => { if (!popup.closed) popup.print(); },150);
  };
  return <div className="flex flex-wrap items-center gap-2 my-2" data-testid="report-actions">
    <select aria-label={`Kertas ${title}`} value={paper} onChange={e => setPaper(e.target.value)} disabled={busy} className="h-9 rounded border border-ui-line bg-ui-card px-2 text-sm"><option>A5</option><option>A4</option></select>
    <Button type="button" variant="outline" size="sm" disabled={disabled || busy || !rows.length} onClick={print}>Cetak{worksheet ? ' Lembar Cek' : ''}</Button>
    <Button type="button" variant="outline" size="sm" disabled={disabled || busy || !rows.length} onClick={excel}>{busy ? 'Menyiapkan…' : worksheet ? 'Lembar Kerja Excel' : 'Ekspor Excel'}</Button>
    <span className="text-xs text-ui-muted">{rows.length} baris sesuai tampilan/filter</span>
  </div>;
}
